/**
 * 文件预览demo
 */
import React from 'react';

import http from '../../axios/http';

import { getBase64 } from '../../util/util.js';

class FileView extends React.Component {

    state = {
        file: null,
    }

    componentDidMount(){
        if(this.props.loadFile != null){
            this.props.loadFile(this.loadFile);
        }
    }

    /**
     * 加载文件
     * @param  options 
     * {
     * url: '文件对应的服务器路径', 必须 
     * fileName: '文件名', 非必须
     * data: {},   //请求参数，非必须
     * saveFile: false, //是否同时保存文件，如果这个为true时，fileName为必填，默认为下载
     * }
     */
    loadFile = (options) => {
        http.download({
            url: options.url,
            data: options.data,
            fileName: options.fileName == null ? "temp.pdf" : options.fileName,
            saveFile: options.saveFile,
            success: (res) => {
                getBase64(res.data).then(base64 => {
                    this.setState({ file: base64 });
                });
            },
            error: (res) => { }
        });
    }

    /**
     * 移除文件显示
     */
    removeFile = () => {
        this.setState({ file: null });
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                {this.state.file == null ? ""
                    : <embed width="100%" height="100%" src={this.state.file} type="application/pdf" />
                }
            </div>
        );
    }
}


export default FileView;